<template>
  <div class="main">
    <div class="nav">
      <div class="center">
        <img src="./images/logo.png">
        <ul>
          <li @click="scrollToSection('section1')">首页</li>
          <li @click="scrollToSection('section2')">解决问题</li>
          <li @click="scrollToSection('section3')">能力介绍</li>
          <li @click="scrollToSection('section4')">业务范围</li>
          <li @click="scrollToSection('section5')">商务合作</li>
          <li @click="scrollToSection('section6')">联系我们</li>
        </ul>
      </div>
    </div>
    <div class="banner" ref="section1">
      <img src="./images/banner.png">
      <div class="right">
        <span style="font-size: 44px;">智慧仓储</span>
        <span style="font-size: 44px;font-weight: bold;">重塑仓储管理新标杆</span>
        <span style="font-size: 18px;color: #000;font-weight: bold;">精准出入库审批，实时库存告警，打造高效仓储管理体系</span>
        <div class="btn">免费试用</div>
      </div>
    </div>
    <div class="solve" ref="section2">
      <div class="center">
        <div class="title">解决问题</div>
        <div class="English">SOLVE PROBLEMS</div>
        <div class="article">
          <div class="square">
            <img src="./images/logo1.png">
            <div class="title">
              出入库流程不规范，审批效率低
            </div>
            <div class="content">
              智慧仓储平台构建标准化出入库审批流程，线上提交申请，审批进度实时跟踪。通过智能提醒和权限管理，确保审批高效进行，避免人为延误，提升仓储作业流转速度。
            </div>
          </div>
          <div class="square">
            <img src="./images/logo2.png">
            <div class="title">
              数据更新延迟，无法准确掌握库存状态
            </div>
            <div class="content">
              平台与各类仓储设备实时数据对接，自动更新库存信息。结合库存告警功能，设置阈值，一旦库存异常，立即通过多种渠道（如短信、系统通知）通知相关人员，让您随时把控库存动态。
            </div>
          </div>
          <div class="square">
            <img src="./images/logo3.png">
            <div class="title">
              库存积压或缺货频繁发生
            </div>
            <div class="content" ref="section3">
              利用大数据分析和智能算法，智慧仓储平台对历史数据和实时数据深度挖掘，精准预测库存需求。配合库存告警和灵活的出入库审批，帮助您优化库存结构，减少积压，避免缺货，降低库存成本。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ability">
      <div class="center">
        <div class="title">能力介绍</div>
        <div class="English">ABILITY INTRODUCTION</div>
        <div class="article">
          <div class="left">
            <img src="./images/picture1.png" style="width: 100%;height: 100%;">
          </div>
          <div class="right">
            <div class="title">出入库审批能力</div>
            <div class="content">
              平台提供高度自定义的出入库审批流程配置，支持多级审批、条件审批。审批节点、审批人、审批权限灵活设置，确保流程符合企业管理需求。审批过程全程留痕，可随时追溯，保障数据安全与操作合规。
            </div>
          </div>
        </div>
        <div class="article">
          <div class="right">
            <div class="title" style="text-align: right;">库存告警能力</div>
            <div class="content">
              通过实时数据采集与分析，智慧仓储平台对库存数量、保质期等关键指标实时监控。支持自定义告警规则，如设置库存上下限、临近保质期天数等。告警方式多样，包括弹窗提醒、短信通知、邮件推送，确保您及时处理库存异常情况。
            </div>
          </div>
          <div class="left" style="background: transparent;">
            <img src="./images/picture2.png" style="width: 100%;margin-top: 50px;">
          </div>
        </div>
        <div class="article">
          <div class="left">
            <img src="./images/picture3.png" style="width: 100%;height: 100%;">
          </div>
          <div class="right">
            <div class="title">综合管理能力</div>
            <div class="content">
              整合仓储各环节数据，实现库存、出入库、设备、人员等全方位管理。提供详细的数据报表和可视化分析，如库存周转率分析、出入库趋势图等，帮助您全面了解仓储运营状况，做出科学决策。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="business" ref="section4">
      <div class="center">
        <div class="title">业务范围</div>
        <div class="English">BUSINESS SCOPE</div>
        <div class="article">

          <div class="left">
            <div class="title">
              仓储管理系统搭建
            </div>
            <div class="content">
              根据企业规模和业务特点，量身定制仓储管理系统。涵盖出入库管理、库存管理、设备管理等核心功能，结合出入库审批和库存告警，优化仓储流程，提升管理效率。
            </div>
          </div>
          <div class="right">
            <div class="title">
              仓储流程优化服务
            </div>
            <div class="content">
              深入分析企业现有仓储流程，利用平台优势进行优化。重点优化出入库审批环节，简化繁琐流程；强化库存监控与告警机制，降低库存风险，提高仓储运营效益。
            </div>
          </div>
        </div>
        <div class="article">
          <div class="left">
            <div class="title">
              数据驱动仓储决策支持
            </div>
            <div class="content">
              运用大数据分析技术，对仓储数据深度挖掘。基于出入库审批数据和库存告警信息，为企业提供库存规划、补货策略、设备采购建议等决策支持，助力企业实现精细化管理。
            </div>
          </div>
          <div class="right">
            <div class="title">
              仓储智能化升级改造
            </div>
            <div class="content" ref="section5">
              引入智能设备与技术，如智能货架、自动分拣系统等，与平台无缝集成。完善出入库审批和库存告警功能在智能化场景下的应用，提升仓储智能化水平，降低人力成本，提高作业精度。
            </div>
          </div>
        </div>
        <div class="logoGroup">
          <img src="./images/logoGroup.png">
        </div>
      </div>
    </div>
    <div class="partner">
      <div class="center">
        <div class="title">商务合作</div>
        <div class="English">BUSINESS COOPERATION</div>
        <div class="article">
          <div class="square">
            <div class="title">
              项目合作
            </div>
            <div class="content">
              针对特定仓储管理项目，提供从需求调研、方案设计、系统开发到上线调试的一站式服务。确保出入库审批和库存告警功能满足项目需求，按时交付高质量成果。
            </div>
          </div>
          <div class="square">
            <div class="title">
              长期合作
            </div>
            <div class="content">
              建立长期战略伙伴关系，提供持续的系统维护、功能升级、数据支持服务。不断优化出入库审批和库存告警功能，适应企业发展变化。
            </div>
          </div>
          <div class="square">
            <div class="title">
              代理合作
            </div>
            <div class="content">
              诚邀合作伙伴成为代理商，共享市场资源。提供全方位支持，包括产品培训、市场推广、技术协助，携手拓展仓储管理市场。
            </div>
          </div>
        </div>
        <div class="table" ref="section6">
          <div class="tableTitle">
            客户信息
          </div>
          <el-form ref="form" :model="form" label-width="450px">
            <el-form-item>
              <span slot="label">
                <span style="color: #fff;">姓名</span>
              </span>
              <el-input placeholder="请输入姓名" v-model="form.name" style="width: 300px;float: left;"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: #fff;">电话</span>
              </span>
              <el-input placeholder="请输入电话" v-model="form.num" style="width: 300px;float: left;"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: #fff;">邮箱</span>
              </span>
              <el-input placeholder="请输入邮箱" v-model="form.mail" style="width: 300px;float: left;"></el-input>
            </el-form-item>
          </el-form>
          <div class="btn">
            申请合作
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="center">
        <div class="left">
          <img src="./images/zbys.png">
          <span style="font-size: 22px;font-weight: bold;margin-bottom: 20px;">北京智步云上科技有限公司</span>
          <span>电话：130-5185-0850</span>
          <span>地址：北京市昌平区北清路1号院8号楼21层1单元2107</span>
        </div>
        <div class="right">
          <img src="./images/erweima.png">
          <span>扫码了解更多</span>
        </div>
        <div class="bottom">北京智步云上科技有限公司 备案/许可证编号：京ICP备2024066658号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      form: {
        name: '',
        num: '',
        mail: '',
      }
    };
  },
  methods: {
    scrollToSection(sectionName) {
      const element = this.$refs[sectionName];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth', // 平滑滚动效果
          block: 'start' // 滚动到元素顶部
        });
      }
    }
  },

};
</script>

<style lang="less" scoped>
.main {
  width: 100%;

  a {
    text-decoration: none;
    /* 去除下划线 */
    color: inherit;
    /* 让链接颜色继承父元素文本颜色，一般为黑色或默认文本颜色 */
    background-color: transparent;
    /* 背景透明 */
    border: none;
    /* 无边框 */
    outline: none;
    /* 移除聚焦时的轮廓 */
  }

  .nav {
    width: 100%;
    height: 120px;
    background: rgba(255, 255, 255, 0.9);
    position: fixed;
    z-index: 999;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;

      img {
        display: block;
        float: left;
        vertical-align: middle;
        margin-top: 41px;
      }

      ul {
        height: 100%;
        list-style: none;
        width: 600px;
        margin: 0 auto;

        li {
          text-decoration-style: none;
          float: left;
          width: 100px;
          height: 100%;
          color: #333;
          font-size: 18px;
          line-height: 120px;
          text-align: center;
          transition: background 0.3s ease, color 0.3s ease;
        }

        li:hover {
          background: rgba(0, 0, 100, 0.3);
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .banner {
    width: 100%;
    height: 625px;
    padding-top: 120px;

    img {
      width: 1039px;
      height: 625px;
      display: block;
      float: left;
    }

    .right {
      width: calc(100% - 1039px);
      height: 625px;
      float: left;
      padding: 120px 0 0 30px;

      span {
        display: block;
        color: #374a85;
        line-height: 80px;
      }

      .btn {
        width: 201px;
        height: 56px;
        font-size: 22px;
        color: #fff;
        letter-spacing: 2px;
        margin-top: 30px;
        border-radius: 25px;
        text-align: center;
        line-height: 56px;
        background: url("./images/Path.png") no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }

  .solve {
    padding: 50px 0;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      text-align: center;

      .title {
        font-size: 28px;
        color: #0069aa;
      }

      .English {
        font-size: 44px;
        color: #000;
        position: relative;
        margin: 10px 0 100px;
      }

      .English::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article {
        width: 100%;
        height: 378px;
      }

      .square {
        width: 350px;
        height: 378px;
        margin: 0 25px;
        float: left;
        box-shadow: 0 4px 8px 0 rgba(173, 216, 230, 0.7);
        transition: box-shadow 0.3s ease, color 0.3s ease;
        /* 浅蓝色阴影 */
        border-radius: 4px;
        padding: 20px;

        img {
          margin-top: 30px;
        }

        .title {
          font-size: 18px;
          color: #000;
          margin-top: 30px;
        }

        .content {
          color: #666;
          line-height: 24px;
          text-align: left;
          margin-top: 30px;
        }
      }

      .square:hover {
        box-shadow: 0 4px 8px 0 rgba(0, 105, 170, 0.7);
      }
    }
  }

  .ability {
    padding: 50px 0;
    background: #fafafa;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      text-align: center;

      .title {
        font-size: 28px;
        color: #0069aa;
      }

      .English {
        font-size: 44px;
        color: #000;
        position: relative;
        margin: 10px 0 100px;
      }

      .English::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article:last-child {
        margin-bottom: 0px;
      }

      .article {
        width: 100%;
        height: 351px;
        margin-bottom: 100px;

        .left {
          width: 554px;
          height: 351px;
          float: left;
          background: #0069aa;
        }

        .right {
          width: calc(100% - 554px);
          height: 351px;
          float: left;
          padding: 35px 100px;
          background: transparent;

          .title {
            font-size: 28px;
            font-weight: bold;
            color: #000;
            text-align: left;
            margin-bottom: 30px;
          }

          .content {
            text-align: left;
            line-height: 36px;
          }
        }
      }
    }
  }

  .business {
    padding: 50px 0;

    .center {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      position: relative;

      .title {
        font-size: 28px;
        color: #0069aa;
      }

      .English {
        font-size: 44px;
        color: #000;
        position: relative;
        margin: 10px 0 100px;
      }

      .English::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article {
        width: 100%;
        height: 250px;

        .left {
          width: 600px;
          height: 250px;
          float: left;
          padding: 30px 55px;
          background: transparent;
          text-align: left;

          .title {
            color: #0069aa;
            font-size: 28px;
            font-weight: bold;
            margin-bottom: 30px;
            padding-left: 80px;
          }

          .content {
            line-height: 35px;
            padding-right: 100px;
          }
        }

        .right {
          width: 600px;
          height: 250px;
          float: left;
          padding: 30px 55px;
          text-align: left;

          .title {
            color: #0069aa;
            font-size: 28px;
            font-weight: bold;
            margin-bottom: 30px;
            padding-left: 180px;
          }

          .content {
            line-height: 35px;
            padding-left: 100px;
          }
        }
      }


      .logoGroup {
        position: absolute;
        top: 350px;
        left: 0;
        bottom: 0;
        right: 0;
        margin: 0 auto;
      }

    }
  }

  .partner {
    padding-top: 50px;
    background: #0069aa;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      text-align: center;

      .title {
        font-size: 28px !important;
        font-weight: normal !important;
        color: #fff;
        border-bottom: none !important;
      }

      .English {
        font-size: 44px;
        color: #fff;
        position: relative;
        margin: 10px 0 100px;
      }

      .English::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #80b4d5;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article {
        width: 100%;
        height: 450px;
        border-bottom: 2px solid #88b9d7;
      }

      .square {
        width: 400px;
        height: 400px;
        float: left;
        padding: 50px 70px 70px;
        transition: box-shadow 0.3s ease, color 0.3s ease, background 1s ease;
        border-radius: 10px;
      }

      .square:hover {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        background: #00588f;
        cursor: pointer;
      }

      .title {
        display: inline-block;
        font-size: 22px;
        font-weight: bold;
        line-height: 44px;
        border-bottom: 2px solid #88b9d7;
      }

      .content {
        text-align: left;
        line-height: 36px;
        margin-top: 30px;
        color: #fff;
      }

      .table {
        width: 100%;
        height: 450px;
        padding-top: 50px;

        .tableTitle {
          color: #fff;
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 60px;
        }

        .btn {
          width: 300px;
          height: 50px;
          background: url("./images/btn.png");
          margin: 0 auto;
          line-height: 50px;
          color: #fff;
          font-size: 20px;
          letter-spacing: 5px;
          border-radius: 5px;
          cursor: pointer;
        }

        .btn:active {
          background: #69a7ff;
        }
      }
    }
  }

  .footer {
    height: 500px;
    width: 100%;
    background: #161f24;
    float: left;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding: 0;

      .left {
        height: 400px;
        float: left;
        padding: 50px 0;
        background: transparent;

        img {
          display: block;
          margin-bottom: 50px;
        }

        span {
          line-height: 30px;
          color: #fff;
          display: block;
        }
      }

      .right {
        height: 400px;
        float: right;
        padding: 50px 0;
        background: transparent;

        img {
          width: 200px;
          height: 200px;
          display: block;
          margin-bottom: 20px;
        }

        span {
          margin-left: 45px;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
        }
      }

      .bottom {
        width: 100%;
        height: 100px;
        float: left;
        text-align: center;
        color: #666;
        line-height: 100px;
      }
    }

  }
}
</style>